import React, { useState, useEffect, useRef } from 'react';
import { API_CONFIG } from '../../config/apiConfig';
import { useAuth } from '../../contexts/SimpleAuthContext';
import {
  PlusIcon,
  XMarkIcon,
  CheckIcon,
  PencilIcon,
  TrashIcon,
  AcademicCapIcon,
  CalendarIcon,
  BuildingOfficeIcon,
  MagnifyingGlassIcon
} from '@heroicons/react/24/outline';

const INSTITUTIONS = [
  // Traditional Universities
  { name: 'University of Cape Town (UCT)', category: 'University' },
  { name: 'University of Fort Hare (UFH)', category: 'University' },
  { name: 'University of the Free State (UFS)', category: 'University' },
  { name: 'University of KwaZulu-Natal (UKZN)', category: 'University' },
  { name: 'University of Limpopo (UL)', category: 'University' },
  { name: 'North-West University (NWU)', category: 'University' },
  { name: 'University of Pretoria (UP)', category: 'University' },
  { name: 'Rhodes University (RU)', category: 'University' },
  { name: 'Sefako Makgatho Health Sciences University (SMU)', category: 'University' },
  { name: 'Stellenbosch University (SU)', category: 'University' },
  { name: 'University of the Western Cape (UWC)', category: 'University' },
  { name: 'University of the Witwatersrand (Wits)', category: 'University' },
  { name: 'University of Venda (Univen)', category: 'University' },
  { name: 'University of Zululand (UniZulu)', category: 'University' },
  { name: 'University of South Africa (UNISA)', category: 'University' },
  
  // Universities of Technology
  { name: 'Cape Peninsula University of Technology (CPUT)', category: 'University of Technology' },
  { name: 'Central University of Technology (CUT)', category: 'University of Technology' },
  { name: 'Durban University of Technology (DUT)', category: 'University of Technology' },
  { name: 'Mangosuthu University of Technology (MUT)', category: 'University of Technology' },
  { name: 'Nelson Mandela University (NMU)', category: 'University of Technology' },
  { name: 'Sol Plaatje University (SPU)', category: 'University of Technology' },
  { name: 'Tshwane University of Technology (TUT)', category: 'University of Technology' },
  { name: 'University of Johannesburg (UJ)', category: 'University of Technology' },
  { name: 'University of Mpumalanga (UMP)', category: 'University of Technology' },
  { name: 'Vaal University of Technology (VUT)', category: 'University of Technology' },
  { name: 'Walter Sisulu University (WSU)', category: 'University of Technology' },

  // TVET Colleges - Eastern Cape
  { name: 'Buffalo City TVET College', category: 'TVET College' },
  { name: 'Eastcape Midlands TVET College', category: 'TVET College' },
  { name: 'Ikhala TVET College', category: 'TVET College' },
  { name: 'Ingwe TVET College', category: 'TVET College' },
  { name: 'King Hintsa TVET College', category: 'TVET College' },
  { name: 'King Sabata Dalindyebo TVET College', category: 'TVET College' },
  { name: 'Lovedale TVET College', category: 'TVET College' },
  { name: 'Port Elizabeth TVET College', category: 'TVET College' },

  // TVET Colleges - Free State
  { name: 'Flavius Mareka TVET College', category: 'TVET College' },
  { name: 'Goldfields TVET College', category: 'TVET College' },
  { name: 'Maluti TVET College', category: 'TVET College' },
  { name: 'Motheo TVET College', category: 'TVET College' },

  // TVET Colleges - Gauteng
  { name: 'Central Johannesburg TVET College', category: 'TVET College' },
  { name: 'Ekurhuleni East TVET College', category: 'TVET College' },
  { name: 'Ekurhuleni West TVET College', category: 'TVET College' },
  { name: 'Sedibeng TVET College', category: 'TVET College' },
  { name: 'South West Gauteng TVET College', category: 'TVET College' },
  { name: 'Tshwane North TVET College', category: 'TVET College' },
  { name: 'Tshwane South TVET College', category: 'TVET College' },
  { name: 'Western TVET College (Westcol)', category: 'TVET College' },

  // TVET Colleges - KwaZulu-Natal
  { name: 'Coastal KZN TVET College', category: 'TVET College' },
  { name: 'Elangeni TVET College', category: 'TVET College' },
  { name: 'Esayidi TVET College', category: 'TVET College' },
  { name: 'Majuba TVET College', category: 'TVET College' },
  { name: 'Mnambithi TVET College', category: 'TVET College' },
  { name: 'Mthashana TVET College', category: 'TVET College' },
  { name: 'Thekwini TVET College', category: 'TVET College' },
  { name: 'Umfolozi TVET College', category: 'TVET College' },
  { name: 'Umgungundlovu TVET College', category: 'TVET College' },

  // TVET Colleges - Limpopo
  { name: 'Capricorn TVET College', category: 'TVET College' },
  { name: 'Lephalale TVET College', category: 'TVET College' },
  { name: 'Letaba TVET College', category: 'TVET College' },
  { name: 'Mopani South East TVET College', category: 'TVET College' },
  { name: 'Sekhukhune TVET College', category: 'TVET College' },
  { name: 'Vhembe TVET College', category: 'TVET College' },
  { name: 'Waterberg TVET College', category: 'TVET College' },

  // TVET Colleges - Mpumalanga
  { name: 'Ehlanzeni TVET College', category: 'TVET College' },
  { name: 'Gert Sibande TVET College', category: 'TVET College' },
  { name: 'Nkangala TVET College', category: 'TVET College' },

  // TVET Colleges - Northern Cape
  { name: 'Northern Cape Rural TVET College', category: 'TVET College' },
  { name: 'Northern Cape Urban TVET College', category: 'TVET College' },

  // TVET Colleges - North West
  { name: 'Orbit TVET College', category: 'TVET College' },
  { name: 'Taletso TVET College', category: 'TVET College' },
  { name: 'Vuselela TVET College', category: 'TVET College' },

  // TVET Colleges - Western Cape
  { name: 'Boland TVET College', category: 'TVET College' },
  { name: 'College of Cape Town', category: 'TVET College' },
  { name: 'False Bay TVET College', category: 'TVET College' },
  { name: 'Northlink TVET College', category: 'TVET College' },
  { name: 'South Cape TVET College', category: 'TVET College' },
  { name: 'West Coast TVET College', category: 'TVET College' }
];

const TertiaryEducation = ({ user }) => {
  const { accessToken, makeAuthenticatedRequest } = useAuth();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const [qualifications, setQualifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showAddForm, setShowAddForm] = useState(false);
  const [editingQualification, setEditingQualification] = useState(null);
  const [formData, setFormData] = useState({
    institution_name: '',
    qualification_name: '',
    education_level: '',
    nqf_level: '',
    field_of_study: '',
    status: 'completed',
    start_date: '',
    end_date: '',
    year_completed: ''
    // Temporarily removed grade_result and gpa_score until migration is applied
  });

  const requestApi = async (path, options = {}) => {
    const response = await makeAuthenticatedRequest(`${API_CONFIG.API_URL}${path}`, options);
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      const requestError = new Error(data.detail || `Request failed (${response.status})`);
      requestError.response = { status: response.status, data };
      throw requestError;
    }
    return { data, status: response.status };
  };

  // Comprehensive South African qualification types
  const QUALIFICATION_TYPES = [
    // University Qualifications
    { value: 'bachelor_degree', label: 'Bachelor\'s Degree', category: 'University' },
    { value: 'honours_degree', label: 'Honours Degree', category: 'University' },
    { value: 'master_degree', label: 'Master\'s Degree', category: 'University' },
    { value: 'doctoral_degree', label: 'Doctoral Degree', category: 'University' },
    { value: 'postgrad_diploma', label: 'Postgraduate Diploma', category: 'University' },
    { value: 'postgrad_certificate', label: 'Postgraduate Certificate', category: 'University' },

    // University of Technology
    { value: 'national_diploma', label: 'National Diploma', category: 'University of Technology' },
    { value: 'btech_degree', label: 'Bachelor of Technology (BTech)', category: 'University of Technology' },
    { value: 'mtech_degree', label: 'Master of Technology (MTech)', category: 'University of Technology' },
    { value: 'dtech_degree', label: 'Doctoral Technology (DTech)', category: 'University of Technology' },

    // TVET College Qualifications
    { value: 'ncv_level2', label: 'National Certificate (Vocational) Level 2', category: 'TVET College' },
    { value: 'ncv_level3', label: 'National Certificate (Vocational) Level 3', category: 'TVET College' },
    { value: 'ncv_level4', label: 'National Certificate (Vocational) Level 4', category: 'TVET College' },
    { value: 'n1_certificate', label: 'National N1 Certificate', category: 'TVET College' },
    { value: 'n2_certificate', label: 'National N2 Certificate', category: 'TVET College' },
    { value: 'n3_certificate', label: 'National N3 Certificate', category: 'TVET College' },
    { value: 'n4_certificate', label: 'National N4 Certificate', category: 'TVET College' },
    { value: 'n5_certificate', label: 'National N5 Certificate', category: 'TVET College' },
    { value: 'n6_certificate', label: 'National N6 Certificate', category: 'TVET College' },
    { value: 'n_diploma', label: 'National N-Diploma', category: 'TVET College' },
    { value: 'occupational_certificate', label: 'Occupational Certificate', category: 'TVET College' },
    { value: 'skills_programme', label: 'Skills Programme', category: 'TVET College' },
    { value: 'learnership', label: 'Learnership', category: 'TVET College' },

    // Professional Qualifications
    { value: 'advanced_diploma', label: 'Advanced Diploma', category: 'Professional' },
    { value: 'higher_certificate', label: 'Higher Certificate', category: 'Professional' },
    { value: 'advanced_certificate', label: 'Advanced Certificate', category: 'Professional' },

    // Short Courses & Certificates
    { value: 'certificate_course', label: 'Certificate Course', category: 'Short Course' },
    { value: 'professional_development', label: 'Professional Development Certificate', category: 'Short Course' },
    { value: 'industry_certification', label: 'Industry Certification', category: 'Short Course' },
    { value: 'short_course', label: 'Short Course', category: 'Short Course' },

    // Other
    { value: 'other', label: 'Other Qualification', category: 'Other' }
  ];

  const STATUS_CHOICES = [
    { value: 'completed', label: 'Completed' },
    { value: 'in_progress', label: 'In Progress' },
    { value: 'partially_completed', label: 'Partially Completed' },
    { value: 'dropped_out', label: 'Dropped Out' }
  ];

  const GRADE_CHOICES = [
    { value: 'distinction', label: 'Distinction' },
    { value: 'cum_laude', label: 'Cum Laude' },
    { value: 'magna_cum_laude', label: 'Magna Cum Laude' },
    { value: 'summa_cum_laude', label: 'Summa Cum Laude' },
    { value: 'pass_with_merit', label: 'Pass with Merit' },
    { value: 'pass', label: 'Pass' },
    { value: 'competent', label: 'Competent' },
    { value: 'not_yet_competent', label: 'Not Yet Competent' },
    { value: 'other', label: 'Other' }
  ];

  const NQF_LEVELS = [
    { value: '1', label: 'NQF Level 1' },
    { value: '2', label: 'NQF Level 2' },
    { value: '3', label: 'NQF Level 3' },
    { value: '4', label: 'NQF Level 4' },
    { value: '5', label: 'NQF Level 5' },
    { value: '6', label: 'NQF Level 6' },
    { value: '7', label: 'NQF Level 7' },
    { value: '8', label: 'NQF Level 8' },
    { value: '9', label: 'NQF Level 9' },
    { value: '10', label: 'NQF Level 10' }
  ];

  useEffect(() => {
    console.log('🔄 TertiaryEducation useEffect triggered');
    console.log('👤 User:', user);
    if (accessToken) {
      fetchQualifications();
    } else {
      setQualifications([]);
      setLoading(false);
    }
  }, [accessToken]);

  const fetchQualifications = async () => {
    if (!accessToken) {
      setQualifications([]);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError('');

      console.log('📡 Fetching tertiary qualifications...');
      const response = await requestApi('/auth/education/');

      console.log('📦 API Response:', response.data);
      console.log('📊 Response status:', response.status);

      // Handle paginated response - extract results array
      let qualificationsData = [];
      if (response.data && Array.isArray(response.data.results)) {
        qualificationsData = response.data.results;
      } else if (Array.isArray(response.data)) {
        qualificationsData = response.data;
      }

      console.log(`✅ Setting ${qualificationsData.length} qualifications:`, qualificationsData);
      setQualifications(qualificationsData);
    } catch (err) {
      console.error('❌ Error fetching qualifications:', err);
      console.error('📄 Error response:', err.response?.data);
      console.error('📊 Error status:', err.response?.status);
      setError('Failed to load qualifications');
      setQualifications([]);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleSubmit();
    }
  };

  const validateForm = () => {
    if (!formData.institution_name.trim()) {
      setError('Institution name is required');
      return false;
    }
    if (!formData.qualification_name.trim()) {
      setError('Qualification name is required');
      return false;
    }
    if (!formData.education_level) {
      setError('Qualification type is required');
      return false;
    }
    if (!formData.status) {
      setError('Status is required');
      return false;
    }

    // Validate dates
    if (formData.start_date && formData.end_date) {
      if (new Date(formData.start_date) > new Date(formData.end_date)) {
        setError('Start date cannot be after end date');
        return false;
      }
    }

    return true;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;

    try {
      setError('');
      console.log('🔄 Submitting qualification:', formData);

      const url = editingQualification
        ? `/api/auth/education/${editingQualification.id}/`
        : '/api/auth/education/';

      const method = editingQualification ? 'put' : 'post';

      console.log(`📡 Making ${method.toUpperCase()} request to:`, url);
      console.log('📦 Request data:', formData);

      // Clean up the form data - remove empty strings and convert dates
      const cleanedData = { ...formData };

      // Remove empty string values
      Object.keys(cleanedData).forEach(key => {
        if (cleanedData[key] === '') {
          delete cleanedData[key];
        }
      });

      // Ensure numeric fields are properly formatted
      if (cleanedData.year_completed) {
        cleanedData.year_completed = parseInt(cleanedData.year_completed);
      }
      if (cleanedData.gpa_score) {
        cleanedData.gpa_score = parseFloat(cleanedData.gpa_score);
      }

      console.log('🧹 Cleaned request data:', cleanedData);

      const response = await requestApi(url.replace('/api', ''), {
        method: method.toUpperCase(),
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(cleanedData),
      });

      console.log('✅ Qualification saved successfully:', response.data);

      // Refresh the qualifications list
      await fetchQualifications();
      resetForm();
      setError('');

      console.log('🔄 Form reset and qualifications refreshed');
    } catch (err) {
      console.error('❌ Error saving qualification:', err);
      console.error('📄 Error response:', err.response?.data);
      console.error('📊 Error status:', err.response?.status);

      // Show detailed error information
      let errorMessage = 'Failed to save qualification';

      if (err.response?.data) {
        const errorData = err.response.data;

        // Handle field-specific errors
        if (typeof errorData === 'object') {
          const fieldErrors = [];
          Object.keys(errorData).forEach(field => {
            if (Array.isArray(errorData[field])) {
              fieldErrors.push(`${field}: ${errorData[field].join(', ')}`);
            } else {
              fieldErrors.push(`${field}: ${errorData[field]}`);
            }
          });

          if (fieldErrors.length > 0) {
            errorMessage = `Validation errors: ${fieldErrors.join('; ')}`;
          }
        } else if (errorData.non_field_errors) {
          errorMessage = errorData.non_field_errors[0];
        } else if (errorData.detail) {
          errorMessage = errorData.detail;
        } else {
          errorMessage = `Failed to save qualification: ${err.response?.status} - ${JSON.stringify(errorData)}`;
        }
      } else {
        errorMessage = `Failed to save qualification: ${err.response?.status || 'Unknown error'}`;
      }

      setError(errorMessage);
    }
  };

  const resetForm = () => {
    setFormData({
      institution_name: '',
      qualification_name: '',
      education_level: '',
      nqf_level: '',
      field_of_study: '',
      status: 'completed',
      start_date: '',
      end_date: '',
      year_completed: ''
      // Temporarily removed grade_result and gpa_score until migration is applied
    });
    setShowAddForm(false);
    setEditingQualification(null);
    setError('');
  };

  const handleEdit = (qualification) => {
    setFormData({
      institution_name: qualification.institution_name || '',
      qualification_name: qualification.qualification_name || '',
      education_level: qualification.education_level || '',
      nqf_level: qualification.nqf_level || '',
      field_of_study: qualification.field_of_study || '',
      status: qualification.status || 'completed',
      start_date: qualification.start_date || '',
      end_date: qualification.end_date || '',
      year_completed: qualification.year_completed || '',
      grade_result: qualification.grade_result || '',
      gpa_score: qualification.gpa_score || ''
    });
    setEditingQualification(qualification);
    setShowAddForm(true);
    setError('');
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this qualification?')) {
      return;
    }

    try {
      console.log('🗑️ Deleting qualification:', id);
      await requestApi(`/auth/education/${id}/`, { method: 'DELETE' });
      console.log('✅ Qualification deleted successfully');
      await fetchQualifications();
    } catch (err) {
      console.error('❌ Error deleting qualification:', err);
      setError('Failed to delete qualification');
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed': return '#10B981';
      case 'in_progress': return '#3B82F6';
      case 'partially_completed': return '#F59E0B';
      case 'dropped_out': return '#EF4444';
      default: return '#6B7280';
    }
  };

  const getQualificationCategory = (educationLevel) => {
    const qualification = QUALIFICATION_TYPES.find(q => q.value === educationLevel);
    return qualification ? qualification.category : 'Other';
  };

  if (loading) {
    return (
      <div style={{
        padding: '20px',
        textAlign: 'center',
        color: '#6B7280'
      }}>
        Loading qualifications...
      </div>
    );
  }

  return (
    <div style={{
      background: 'white',
      border: '1px solid #E5E7EB',
      borderRadius: '12px',
      padding: '20px',
      marginBottom: '20px'
    }}>
      {/* Header */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px',
        paddingBottom: '16px',
        borderBottom: '1px solid #E5E7EB'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <AcademicCapIcon style={{
            width: '24px',
            height: '24px',
            color: 'var(--primary-yellow)'
          }} />
          <div>
            <h5 style={{
              margin: '0 0 4px 0',
              fontSize: '18px',
              fontWeight: '600',
              color: 'var(--primary-black)'
            }}>
              Tertiary Education & Qualifications
            </h5>
            <p style={{
              margin: 0,
              fontSize: '14px',
              color: '#6B7280'
            }}>
              Add your post-secondary qualifications and certifications
            </p>
          </div>
        </div>

        {!showAddForm && (
          <div style={{ display: 'flex', gap: '8px' }}>
            <button
              onClick={() => setShowAddForm(true)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                padding: '8px 16px',
                background: 'var(--primary-yellow)',
                color: 'var(--primary-black)',
                border: 'none',
                borderRadius: '8px',
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.2s ease'
              }}
              onMouseOver={(e) => e.target.style.background = '#E5B800'}
              onMouseOut={(e) => e.target.style.background = 'var(--primary-yellow)'}
            >
              <PlusIcon style={{ width: '16px', height: '16px' }} />
              Add Qualification
            </button>

            {/* Debug button - remove in production */}
            <button
              onClick={() => {
                console.log('🔍 Debug Info:');
                console.log('User:', user);
                console.log('Qualifications:', qualifications);
                console.log('Loading:', loading);
                console.log('Error:', error);
                fetchQualifications();
              }}
              style={{
                padding: '8px 12px',
                background: '#F3F4F6',
                color: '#374151',
                border: '1px solid #D1D5DB',
                borderRadius: '8px',
                fontSize: '12px',
                cursor: 'pointer'
              }}
              title="Debug: Check console and refresh qualifications"
            >
              🔍 Debug
            </button>
          </div>
        )}
      </div>

      {error && (
        <div style={{
          padding: '12px',
          background: '#FEE2E2',
          border: '1px solid #FECACA',
          borderRadius: '8px',
          color: '#DC2626',
          fontSize: '14px',
          marginBottom: '16px'
        }}>
          {error}
        </div>
      )}

      {/* Add/Edit Form */}
      {showAddForm && (
        <div style={{
          background: '#F9FAFB',
          border: '1px solid #E5E7EB',
          borderRadius: '12px',
          padding: '20px',
          marginBottom: '20px'
        }}>
          <h6 style={{
            margin: '0 0 16px 0',
            color: 'var(--primary-black)',
            fontSize: '16px',
            fontWeight: '600'
          }}>
            {editingQualification ? 'Edit Qualification' : 'Add New Qualification'}
          </h6>

          <div>
            {/* Institution and Qualification Name */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
              <div ref={dropdownRef}>
                <label style={{
                  display: 'block',
                  marginBottom: '6px',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: 'var(--primary-black)'
                }}>
                  Institution Name *
                </label>
                <div className="custom-autocomplete-container">
                  <MagnifyingGlassIcon 
                    className="search-icon" 
                    style={{ 
                      position: 'absolute', 
                      left: '12px', 
                      top: '50%', 
                      transform: 'translateY(-50%)', 
                      width: '18px', 
                      height: '18px', 
                      color: '#9ca3af',
                      zIndex: 10
                    }} 
                  />
                  <input
                    type="text"
                    name="institution_name"
                    value={formData.institution_name}
                    onChange={(e) => {
                      handleInputChange(e);
                      setIsDropdownOpen(true);
                    }}
                    onFocus={() => setIsDropdownOpen(true)}
                    onKeyPress={handleKeyPress}
                    className="custom-autocomplete-input"
                    placeholder="Type to search institutions..."
                    required
                    autoComplete="off"
                  />
                  
                  {isDropdownOpen && (
                    <div className="custom-autocomplete-dropdown">
                      {INSTITUTIONS.filter(inst =>
                        !formData.institution_name || inst.name.toLowerCase().includes(formData.institution_name.toLowerCase())
                      ).length > 0 ? (
                        INSTITUTIONS
                          .filter(inst =>
                            !formData.institution_name || inst.name.toLowerCase().includes(formData.institution_name.toLowerCase())
                          )
                          .map((inst, index) => (
                            <div 
                              key={index} 
                              className="custom-autocomplete-item"
                              onClick={() => {
                                setFormData(prev => ({
                                  ...prev,
                                  institution_name: inst.name
                                }));
                                setIsDropdownOpen(false);
                              }}
                            >
                              <span style={{ fontWeight: '500' }}>{inst.name}</span>
                              <span className="item-category">{inst.category}</span>
                            </div>
                          ))
                      ) : (
                        <div 
                          className="custom-autocomplete-item custom-autocomplete-action"
                          onClick={() => setIsDropdownOpen(false)}
                        >
                          <PlusIcon style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                          <span>Use "{formData.institution_name}"</span>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>

              <div>
                <label style={{
                  display: 'block',
                  marginBottom: '6px',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: 'var(--primary-black)'
                }}>
                  Qualification Name *
                </label>
                <input
                  type="text"
                  name="qualification_name"
                  value={formData.qualification_name}
                  onChange={handleInputChange}
                  onKeyPress={handleKeyPress}
                  required
                  placeholder="e.g. Bachelor of Science in Computer Science"
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    border: '1px solid #D1D5DB',
                    borderRadius: '8px',
                    fontSize: '14px'
                  }}
                />
              </div>
            </div>

            {/* Qualification Type and NQF Level */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
              <div>
                <label style={{
                  display: 'block',
                  marginBottom: '6px',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: 'var(--primary-black)'
                }}>
                  Qualification Type *
                </label>
                <select
                  name="education_level"
                  value={formData.education_level}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    border: '1px solid #D1D5DB',
                    borderRadius: '8px',
                    fontSize: '14px',
                    background: 'white'
                  }}
                >
                  <option value="">Select qualification type</option>
                  {Object.entries(
                    QUALIFICATION_TYPES.reduce((acc, qual) => {
                      if (!acc[qual.category]) acc[qual.category] = [];
                      acc[qual.category].push(qual);
                      return acc;
                    }, {})
                  ).map(([category, qualifications]) => (
                    <optgroup key={category} label={category}>
                      {qualifications.map(qual => (
                        <option key={qual.value} value={qual.value}>
                          {qual.label}
                        </option>
                      ))}
                    </optgroup>
                  ))}
                </select>
              </div>

              <div>
                <label style={{
                  display: 'block',
                  marginBottom: '6px',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: 'var(--primary-black)'
                }}>
                  NQF Level (Optional)
                </label>
                <select
                  name="nqf_level"
                  value={formData.nqf_level}
                  onChange={handleInputChange}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    border: '1px solid #D1D5DB',
                    borderRadius: '8px',
                    fontSize: '14px',
                    background: 'white'
                  }}
                >
                  <option value="">Select NQF level</option>
                  {NQF_LEVELS.map(level => (
                    <option key={level.value} value={level.value}>
                      {level.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Field of Study and Status */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
              <div>
                <label style={{
                  display: 'block',
                  marginBottom: '6px',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: 'var(--primary-black)'
                }}>
                  Field of Study (Optional)
                </label>
                <input
                  type="text"
                  name="field_of_study"
                  value={formData.field_of_study}
                  onChange={handleInputChange}
                  onKeyPress={handleKeyPress}
                  placeholder="e.g. Computer Science, Engineering, Business"
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    border: '1px solid #D1D5DB',
                    borderRadius: '8px',
                    fontSize: '14px'
                  }}
                />
              </div>

              <div>
                <label style={{
                  display: 'block',
                  marginBottom: '6px',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: 'var(--primary-black)'
                }}>
                  Status *
                </label>
                <select
                  name="status"
                  value={formData.status}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    border: '1px solid #D1D5DB',
                    borderRadius: '8px',
                    fontSize: '14px',
                    background: 'white'
                  }}
                >
                  {STATUS_CHOICES.map(status => (
                    <option key={status.value} value={status.value}>
                      {status.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Dates */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
              <div>
                <label style={{
                  display: 'block',
                  marginBottom: '6px',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: 'var(--primary-black)'
                }}>
                  Start Date (Optional)
                </label>
                <input
                  type="date"
                  name="start_date"
                  value={formData.start_date}
                  onChange={handleInputChange}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    border: '1px solid #D1D5DB',
                    borderRadius: '8px',
                    fontSize: '14px'
                  }}
                />
              </div>

              <div>
                <label style={{
                  display: 'block',
                  marginBottom: '6px',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: 'var(--primary-black)'
                }}>
                  {formData.status === 'completed' ? 'Completion Date' : 'Expected Completion Date'} (Optional)
                </label>
                <input
                  type="date"
                  name="end_date"
                  value={formData.end_date}
                  onChange={handleInputChange}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    border: '1px solid #D1D5DB',
                    borderRadius: '8px',
                    fontSize: '14px'
                  }}
                />
              </div>
            </div>

            {/* Grade and Year Completed */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '20px' }}>
              <div>
                <label style={{
                  display: 'block',
                  marginBottom: '6px',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: 'var(--primary-black)'
                }}>
                  Grade/Result (Optional)
                </label>
                <select
                  name="grade_result"
                  value={formData.grade_result}
                  onChange={handleInputChange}
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    border: '1px solid #D1D5DB',
                    borderRadius: '8px',
                    fontSize: '14px',
                    background: 'white'
                  }}
                >
                  <option value="">Select grade/result</option>
                  {GRADE_CHOICES.map(grade => (
                    <option key={grade.value} value={grade.value}>
                      {grade.label}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label style={{
                  display: 'block',
                  marginBottom: '6px',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: 'var(--primary-black)'
                }}>
                  Year Completed (Optional)
                </label>
                <input
                  type="number"
                  name="year_completed"
                  value={formData.year_completed}
                  onChange={handleInputChange}
                  onKeyPress={handleKeyPress}
                  min="1990"
                  max={new Date().getFullYear() + 5}
                  placeholder="e.g. 2023"
                  style={{
                    width: '100%',
                    padding: '10px 12px',
                    border: '1px solid #D1D5DB',
                    borderRadius: '8px',
                    fontSize: '14px'
                  }}
                />
              </div>
            </div>

            {/* Action Buttons */}
            <div style={{ display: 'flex', gap: '12px' }}>
              <button
                type="button"
                onClick={handleSubmit}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '10px 20px',
                  background: 'var(--primary-yellow)',
                  color: 'var(--primary-black)',
                  border: 'none',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: 'pointer'
                }}
              >
                <CheckIcon style={{ width: '16px', height: '16px' }} />
                {editingQualification ? 'Update Qualification' : 'Add Qualification'}
              </button>

              <button
                type="button"
                onClick={resetForm}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  padding: '10px 20px',
                  background: '#F3F4F6',
                  color: '#374151',
                  border: '1px solid #D1D5DB',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '600',
                  cursor: 'pointer'
                }}
              >
                <XMarkIcon style={{ width: '16px', height: '16px' }} />
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Qualifications List */}
      {!Array.isArray(qualifications) || qualifications.length === 0 ? (
        <div style={{
          textAlign: 'center',
          padding: '40px 20px',
          background: '#F9FAFB',
          border: '1px solid #E5E7EB',
          borderRadius: '12px',
          color: '#6B7280'
        }}>
          <AcademicCapIcon style={{
            width: '48px',
            height: '48px',
            margin: '0 auto 16px',
            color: '#D1D5DB'
          }} />
          <p style={{ margin: '0 0 8px 0', fontSize: '16px', fontWeight: '500' }}>
            No qualifications added yet
          </p>
          <p style={{ margin: 0, fontSize: '14px' }}>
            Add your tertiary education qualifications to complete your profile
          </p>
        </div>
      ) : (
        <div style={{ display: 'grid', gap: '16px' }}>
          {Array.isArray(qualifications) && qualifications.map(qualification => (
            <div
              key={qualification.id}
              style={{
                background: 'white',
                border: '1px solid #E5E7EB',
                borderRadius: '12px',
                padding: '20px',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ flex: 1 }}>
                  {/* Qualification Header */}
                  <div style={{ marginBottom: '12px' }}>
                    <h6 style={{
                      margin: '0 0 4px 0',
                      fontSize: '18px',
                      fontWeight: '600',
                      color: 'var(--primary-black)'
                    }}>
                      {qualification.qualification_name}
                    </h6>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px' }}>
                      <BuildingOfficeIcon style={{ width: '16px', height: '16px', color: '#6B7280' }} />
                      <span style={{ fontSize: '14px', color: '#6B7280' }}>
                        {qualification.institution_name}
                      </span>
                    </div>
                  </div>

                  {/* Qualification Details */}
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px' }}>
                    <div>
                      <span style={{ fontSize: '12px', color: '#6B7280', fontWeight: '500' }}>Type:</span>
                      <p style={{ margin: '2px 0 0 0', fontSize: '14px', color: 'var(--primary-black)' }}>
                        {qualification.education_level_display}
                      </p>
                    </div>

                    {qualification.field_of_study && (
                      <div>
                        <span style={{ fontSize: '12px', color: '#6B7280', fontWeight: '500' }}>Field:</span>
                        <p style={{ margin: '2px 0 0 0', fontSize: '14px', color: 'var(--primary-black)' }}>
                          {qualification.field_of_study}
                        </p>
                      </div>
                    )}

                    <div>
                      <span style={{ fontSize: '12px', color: '#6B7280', fontWeight: '500' }}>Status:</span>
                      <div style={{ margin: '2px 0 0 0' }}>
                        <span style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '4px',
                          padding: '2px 8px',
                          background: getStatusColor(qualification.status),
                          color: 'white',
                          borderRadius: '12px',
                          fontSize: '12px',
                          fontWeight: '600'
                        }}>
                          {qualification.status_display}
                        </span>
                      </div>
                    </div>

                    {qualification.grade_result && (
                      <div>
                        <span style={{ fontSize: '12px', color: '#6B7280', fontWeight: '500' }}>Grade:</span>
                        <p style={{ margin: '2px 0 0 0', fontSize: '14px', color: 'var(--primary-black)' }}>
                          {qualification.grade_result_display}
                        </p>
                      </div>
                    )}

                    {(qualification.year_completed || qualification.end_date) && (
                      <div>
                        <span style={{ fontSize: '12px', color: '#6B7280', fontWeight: '500' }}>
                          {qualification.status === 'completed' ? 'Completed:' : 'Expected:'}
                        </span>
                        <div style={{ margin: '2px 0 0 0', display: 'flex', alignItems: 'center', gap: '4px' }}>
                          <CalendarIcon style={{ width: '14px', height: '14px', color: '#6B7280' }} />
                          <span style={{ fontSize: '14px', color: 'var(--primary-black)' }}>
                            {qualification.year_completed || new Date(qualification.end_date).getFullYear()}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {/* Action Buttons */}
                <div style={{ display: 'flex', gap: '8px', marginLeft: '16px' }}>
                  <button
                    onClick={() => handleEdit(qualification)}
                    style={{
                      padding: '8px',
                      background: '#F3F4F6',
                      border: '1px solid #D1D5DB',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                    title="Edit qualification"
                  >
                    <PencilIcon style={{ width: '16px', height: '16px', color: '#6B7280' }} />
                  </button>

                  <button
                    onClick={() => handleDelete(qualification.id)}
                    style={{
                      padding: '8px',
                      background: '#FEE2E2',
                      border: '1px solid #FECACA',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                    title="Delete qualification"
                  >
                    <TrashIcon style={{ width: '16px', height: '16px', color: '#DC2626' }} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TertiaryEducation;
